module.exports = __webpack_public_path__ + "static/media/Empty-page.070e9d83.svg";